module.exports = __webpack_public_path__ + "img/SES_210422550.31098974.jpg";